// GTM Email Utils
// Shared helpers for extracting email from form events, DOM inputs, and request bodies.

(function() {
  function normalizeEmail(value) {
    var text = String(value || '').trim();
    if (!text) return '';

    var emailMatch = text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    return emailMatch ? emailMatch[0] : '';
  }

  function getEmailFromDetail(detail, depth) {
    var level = typeof depth === 'number' ? depth : 0;
    if (!detail || level > 3) return '';

    if (typeof detail === 'string') {
      return normalizeEmail(detail);
    }

    if (Array.isArray(detail)) {
      for (var i = 0; i < detail.length; i += 1) {
        var arrayEmail = getEmailFromDetail(detail[i], level + 1);
        if (arrayEmail) return arrayEmail;
      }
      return '';
    }

    if (typeof detail === 'object') {
      for (var key in detail) {
        if (!Object.prototype.hasOwnProperty.call(detail, key)) continue;

        var value = detail[key];
        if (typeof value === 'string' && key.toLowerCase().includes('email')) {
          var keyedEmail = normalizeEmail(value);
          if (keyedEmail) return keyedEmail;
        }

        var nestedEmail = getEmailFromDetail(value, level + 1);
        if (nestedEmail) return nestedEmail;
      }
    }

    return '';
  }

  function getEmailFromForm(extraSelectors) {
    if (window.__quoteFormEmail) {
      var quoteEmail = normalizeEmail(window.__quoteFormEmail);
      if (quoteEmail) return quoteEmail;
    }

    var selectors = [
      'form input[type="email"]',
      'form #email',
      'form input[name="email"]',
      'form input[name*="email" i]',
      'input[type="email"]',
      '#email',
      'input[name="email"]',
      'input[name*="email" i]'
    ];

    if (Array.isArray(extraSelectors) && extraSelectors.length) {
      selectors = extraSelectors.concat(selectors);
    }

    for (var i = 0; i < selectors.length; i += 1) {
      var element = document.querySelector(selectors[i]);
      var formEmail = normalizeEmail(element && element.value);
      if (formEmail) {
        return formEmail;
      }
    }

    return '';
  }

  function getEmailFromBody(body) {
    if (!body) return '';

    if (typeof body === 'string') {
      return normalizeEmail(body);
    }

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var foundEmail = '';
        body.forEach(function(value, key) {
          if (foundEmail) return;

          if (String(key || '').toLowerCase().includes('email')) {
            foundEmail = normalizeEmail(value);
            if (foundEmail) return;
          }

          foundEmail = normalizeEmail(value);
        });

        return foundEmail;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return normalizeEmail(body.toString());
      }
    } catch (e) {
      return '';
    }

    return '';
  }

  function getEventEmail(detail, requestBody, extraSelectors) {
    var detailEmail = getEmailFromDetail(detail, 0);
    if (detailEmail) return detailEmail;

    var formEmail = getEmailFromForm(extraSelectors);
    if (formEmail) return formEmail;

    return getEmailFromBody(requestBody);
  }

  window.GTMEmailUtils = {
    normalizeEmail: normalizeEmail,
    getEmailFromDetail: getEmailFromDetail,
    getEmailFromForm: getEmailFromForm,
    getEmailFromBody: getEmailFromBody,
    getEventEmail: getEventEmail
  };
})();
